import { convert, LocalDate } from '@js-joda/core';
import styled from 'styled-components';

import { Bean, dateFormatter } from '@dreryk/react-common';
import { ValueRendererProps } from '@dreryk/react-components';

export const StyledLocalDateCell = styled.div`
   display: flex;
   gap: 4px;
   justify-content: space-between;
   align-items: center;
   width: 100%;
`;

StyledLocalDateCell.displayName = 'StyledLocalDateCell';

export const LocalDateCell = (props: Pick<ValueRendererProps<Bean, LocalDate>, 'value'>): JSX.Element => {
   return <>{dateFormatter(convert(props.value).toDate())}</>;
};
